<div class="demooz_progress_bar"
    [class.small]="this.sizeProgressBar === 'small'"
    [class.very_small]="this.sizeProgressBar === 'very-small'"
    [class.small_value]="this.pourcent < 50"
    [class.with_margin]="this.withMargin"
    [class.secondary]="this.colorProgressBar === 'secondary'"
    [class.blue]="this.colorProgressBar === 'blue'"
    [class.red]="this.colorProgressBar === 'red'"
    [class.green]="this.colorProgressBar === 'green'"
    [class.orange]="this.colorProgressBar === 'orange'"
    [class.purple]="this.colorProgressBar === 'purple'"
    >
    <div class="demooz_progress_bar_content">
        <div class="demooz_progress_bar_content_value" [style]="{'width': this.pourcent+'%'}">
            <div class="demooz_progress_bar_value">
                @if(this.showValue){
                    <div class="demooz_progress_bar_value_label">{{(this.showPourcent ? this.pourcent+'%' : this.valueProgressBar)}}</div>
                }
            </div>
            @if(this.showSepValue){
                <div class="demooz_progress_bar_value_sep"></div>   
            }
        </div>
    </div>
   
    @if(this.showMax){
        <div class="demooz_progress_bar_max">{{(this.showPourcent ? '100%' : this.maxProgressBar)}}</div>
    }
</div>